import { useTranslation } from "react-i18next";

const StreakIndicator = ({ sevenDayBooleanArray }) => {
    const { t } = useTranslation();

    if (!Array.isArray(sevenDayBooleanArray) || sevenDayBooleanArray.length !== 7) {
        throw new Error("sevenDayBooleanArray must be an array of 7 boolean values");
    }

    return (
        <div className="flex space-x-1 items-center">
            {sevenDayBooleanArray.map((isActive, index) => (
                <div
                    key={index}
                    className={`w-2 h-2 rounded-full ${
                        isActive ? "bg-primary" : "border border-gray-300 bg-gray-50"
                    }`}
                />
            ))}
            <p className="pl-2 text-xs text-gray-500">{t("thisweek")}</p>
        </div>
    );
};

export default StreakIndicator;
